import { API } from "@/lib/api";

// Sends the browser to our backend's Google sign-in. After Google, the backend sets the
// session cookie and redirects to `next` (or to /profile for a first-time user).
// `next` must be a path on this site, e.g. "/dashboard" or "/universities/oxford".
export function startGoogleLogin(next = "/dashboard") {
  window.location.href = `${API}/auth/google/start?next=${encodeURIComponent(next)}`;
}
